const expresion = /^(?<hours>0?[0-9]|1[0-9]|2[0-3])(:(?<minutes>[0-5][0-9]))?$/; // HH:mm | h:mm | h

export const parseTime = (string) => {
  
  if ([null, undefined, ""].includes(string)) return "";

  const match = string.match(expresion);
  let hours = match.groups.hours;
  hours = hours.length == 1 ? `0${hours}` : hours;

  let minutes = match.groups?.minutes || "00";

  return `${hours}:${minutes}`;
};
